import { render } from "./SvgBrakes.vue?vue&type=template&id=2e0f5883&ts=true"
import script from "./SvgBrakes.vue?vue&type=script&lang=ts"
export * from "./SvgBrakes.vue?vue&type=script&lang=ts"

import "./SvgBrakes.vue?vue&type=style&index=0&id=2e0f5883&lang=css"

import exportComponent from "/builds/knx-core/freightbox/freightbox-monorepo-vue/services/eleos-driver-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__